import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import FiveRow from "./FiveRow";

const FourRow = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            R_del_dis,
            R_anotherInputWakil,
            R_frosth,
            R_joripara,
            R_kamkrdnawayNrxID,
            R_kamkrdnawayNrx$,
            R_zh_barez,
            R_search_wakil,
            dolartodinar,
            R_waslKrdn,
            R_total,
            R_totalID,
            R_paraDanID,
            R_paraDan$,
            dinartodolar,
            R_waslKrdnID,
            R_dashkan,
            R_dashkanID,
            R_save,
            R_search_wasl,
            R_open,
            openUpdate,
            R_wasl,
            L_user,
            updateSale,
            loading,
            hideLoader,
            showLoader,
            onSaveRent,
            R_table,
            R_pageminsone,
            R_pageplusone
          } = value;
          return (
            <>
              <div className="row">
                <div className="col-sm-5 text-right mt-2">
                  <div className="form-group">
                    {R_joripara == "دۆلار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ کۆی گشتی
                        </label>
                        <NumberFormat
                          value={R_total}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                          className="form-control text-center bg-white f5"
                        />
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID کۆی گشتی
                        </label>
                        <NumberFormat
                          value={R_totalID}
                          displayType={"text"}
                          className="form-control text-center bg-white f5"
                          thousandSeparator={true}
                          prefix={"ID"}
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className="col-5 text-right mt-2">
                  <div className="form-group">
                    {R_joripara == "دینار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ کۆی گشتی
                        </label>
                        <NumberFormat
                          value={
                            R_paraDanID != 0 && R_paraDanID != ""
                              ? dinartodolar(R_waslKrdnID())
                              : dinartodolar(R_kamkrdnawayNrxID())
                          }
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                          className="form-control text-center bg-white f5"
                        />
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID کۆی گشتی
                        </label>
                        <NumberFormat
                          value={
                            R_paraDan$ != 0 && R_paraDan$ != ""
                              ? dolartodinar(R_waslKrdn())
                              : dolartodinar(R_kamkrdnawayNrx$())
                          }
                          displayType={"text"}
                          className="form-control text-center bg-white f5"
                          thousandSeparator={true}
                          prefix={"ID"}
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className="col-2 text-right mt-5">
                  {R_search_wasl != null ? (
                    <>
                      {R_open == null ? (
                        <button
                          onClick={(e) =>
                            openUpdate(
                              R_wasl.numberOfWakil,
                              L_user._id,
                              e,
                              R_wasl._id
                            )
                          }
                          className="btn btn-warning "
                          style={{
                            backgroundColor: "silver",
                            border: "1px solid silver"
                          }}
                        >
                          <i className="fas fa-lock"></i>
                        </button>
                      ) : (
                        <button
                          onClick={(e) =>
                            updateSale(R_wasl.numberOfWakil, R_wasl._id, e)
                          }
                          className="btn btn-primary "
                          style={{ backgroundColor: "navy" }}
                        >
                          <i className="fas fa-edit "></i>
                        </button>
                      )}
                    </>
                  ) : R_save == true ? (
                    <>
                      {R_open == null ? (
                        <button
                          onClick={(e) =>
                            openUpdate(
                              R_wasl.numberOfWakil,
                              L_user._id,
                              e,
                              R_wasl._id
                            )
                          }
                          className="btn btn-warning "
                          style={{
                            backgroundColor: "silver",
                            border: "1px solid silver"
                          }}
                        >
                          <i className="fas fa-lock"></i>
                        </button>
                      ) : (
                        <button
                          onClick={(e) =>
                            updateSale(R_wasl.numberOfWakil, R_wasl._id, e)
                          }
                          className="btn btn-primary "
                          style={{ backgroundColor: "navy" }}
                        >
                          <i className="fas fa-edit "></i>
                        </button>
                      )}
                    </>
                  ) : (
                    <>
                      {loading ? (
                        <button
                          type="button"
                          onDoubleClick={hideLoader}
                          className="btn btn-success "
                        >
                          <i clasName="fas fa-spinner animate__animated animate__rotateIn animate__infinite"></i>
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={(e) => {
                            showLoader(e);
                            onSaveRent(e);
                          }}
                          className="btn btn-success"
                        >
                          <i className="far fa-save fa-lg"></i>
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
              {/*seconnd row  */}
              <div className="row ">
                <div className="col-5 text-right mt-2">
                  <div className="form-group">
                    {R_joripara == "دۆلار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ کەمکردنەوە
                        </label>
                        <input
                          type="number"
                          disabled={R_del_dis == true ? true : null}
                          name="R_dashkan"
                          onChange={AddProChange}
                          value={R_dashkan == 0 ? "" : R_dashkan}
                          style={{ padding: "8px 4px" }}
                          className={`f5 form-control text-right font-weight-bold text-center ${
                            R_save == true || R_search_wasl == true
                              ? "bg-white"
                              : ""
                          }`}
                        />
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID کەمکردنەوە
                        </label>
                        <input
                          type="number"
                          disabled={R_del_dis == true ? true : null}
                          name="R_dashkanID"
                          onChange={AddProChange}
                          value={R_dashkanID == 0 ? "" : R_dashkanID}
                          style={{
                            padding: "8px 4px",
                            backgroundColor: `${
                              R_save == true || R_search_wasl == true
                                ? "white"
                                : ""
                            }`
                          }}
                          className={`f5 form-control text-center text-right font-weight-bold`}
                        />
                      </>
                    )}
                  </div>
                </div>
                {/* paray pash dashkan */}
                <div className="col-5 text-right mt-2">
                  <div className="form-group">
                    {R_joripara == "دۆلار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ پارەی ماوە
                        </label>
                        {R_dashkan != 0 ? (
                          <>
                            <NumberFormat
                              value={R_kamkrdnawayNrx$()}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                              className="f5 form-control text-center bg-white"
                            />
                          </>
                        ) : (
                          <>
                            <NumberFormat
                              value={R_total}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                              className="f5 form-control text-center bg-white"
                            />
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID پارەی ماوە
                        </label>
                        {R_dashkanID != 0 ? (
                          <>
                            <NumberFormat
                              value={R_kamkrdnawayNrxID()}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"ID"}
                              className="f5 form-control text-center bg-white "
                            />
                          </>
                        ) : (
                          <>
                            <NumberFormat
                              value={R_totalID}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"ID"}
                              className="f5 form-control text-center bg-white"
                            />
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="col-2 text-right mt-4">
                  <div className="form-group">
                    <button
                      className="btn btn-dark p3 px-4 ml3 mt-3"
                      disabled={R_open == true || R_table == true ? true : null}
                      onClick={R_pageplusone}
                      style={{
                        backgroundColor: "#00695c",
                        border: "1px solid #00695c"
                      }}
                    >
                      <i className="fas fa-caret-right f4"></i>
                    </button>
                  </div>
                </div>
              </div>

              {/*Third row  */}
              <div className="row card-header p-1 border-bottom border-warning">
                <div className="col-5 text-right mt-2">
                  <div className="form-group">
                    {R_joripara == "دۆلار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ پارەی دراو
                        </label>
                        <NumberFormat
                          displayType={"input"}
                          thousandSeparator={true}
                          disabled={R_del_dis == true ? true : null}
                          name="R_paraDan$"
                          onChange={AddProChange}
                          value={R_paraDan$}
                          style={{
                            padding: "8px 4px",
                            backgroundColor: `${
                              R_save == true || R_search_wasl == true
                                ? "white"
                                : ""
                            }`
                          }}
                          className={`f5 form-control text-right font-weight-bold text-center`}
                        />
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID پارەی دراو
                        </label>
                        <NumberFormat
                          disabled={R_del_dis == true ? true : null}
                          name="R_paraDanID"
                          onChange={AddProChange}
                          value={R_paraDanID}
                          style={{ padding: "8px 4px" }}
                          className={`f5 form-control text-right font-weight-bold text-center ${
                            R_save == true || R_search_wasl == true
                              ? "bg-white"
                              : ""
                          }`}
                          displayType={"input"}
                          thousandSeparator={true}
                        />
                      </>
                    )}
                  </div>
                </div>
                {/* paray pash dashkan */}
                <div className="col-5 text-right mt-2">
                  <div className="form-group">
                    {R_joripara == "دۆلار" ? (
                      <>
                        <label className="font-weight-bold f4">
                          :$ پارەی نەدراو
                        </label>
                        {R_paraDan$ != 0 && R_paraDan$ != "" ? (
                          <>
                            <NumberFormat
                              value={R_waslKrdn()}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                              className="f5 form-control text-right font-weight-bold text-center"
                            />
                          </>
                        ) : (
                          <>
                            <NumberFormat
                              value={R_kamkrdnawayNrx$()}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                              className="f5 form-control text-right font-weight-bold text-center"
                            />
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <label className="font-weight-bold f4">
                          :ID پارەی نەدراو
                        </label>
                        {R_paraDanID != 0 && R_paraDanID != "" ? (
                          <>
                            <NumberFormat
                              value={R_waslKrdnID()}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"ID"}
                              className="f5 form-control text-right font-weight-bold text-center"
                            />
                          </>
                        ) : (
                          <>
                            <NumberFormat
                              value={R_kamkrdnawayNrxID()}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"ID"}
                              className="f5 form-control text-right font-weight-bold text-center"
                            />
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="col-2 text-right mt-4">
                  <div className="form-group ">
                    <button
                      className="btn btn-dark p3 px-4 mt-3"
                      disabled={R_open == true || R_table == true ? true : null}
                      onClick={R_pageminsone}
                      style={{
                        backgroundColor: "#00695c",
                        border: "1px solid #00695c"
                      }}
                    >
                      <i className="fas fa-caret-left f4"></i>
                    </button>
                  </div>
                </div>
              </div>

              {/* fourth Row */}
              {/* <FiveRow/> */}
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default FourRow;
